<template>
  <!-- Éxito: aviso compacto arriba a la derecha que se cierra solo -->
  <v-snackbar
    v-if="!esError"
    v-model="visible"
    app
    top
    right
    :timeout="3000"
    color="#2e7d32"
    elevation="6"
    min-width="0"
    max-width="380"
    content-class="alerta-exito"
  >
    <div class="d-flex align-center">
      <v-icon small color="white" class="mr-2">mdi-check-circle</v-icon>
      <span class="alerta-exito__texto">{{ parametros.mensaje }}</span>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn icon x-small dark v-bind="attrs" @click="cerrar">
        <v-icon x-small>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>

  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-else
    v-model="parametros.dialogError"
    max-width="440"
    persistent
    scrollable
  >
    <v-card>
    	<v-card-text>
  			<v-card class="elevation-0 text-center pt-4">
  				<v-icon color="error" large class="mb-3">mdi-alert-circle-outline</v-icon>
  				<span class="text-headline" style="white-space: pre-line">
  				 	{{ parametros.mensaje }}
  				</span>
  			</v-card>
    	</v-card-text>
    	<v-card-actions class="flex-column pa-4 pt-0">
        <v-btn
          color="warning"
          depressed
          block
          large
          class="text-capitalize mb-2"
          @click="reportarProblema"
        >
          <v-icon left small>mdi-bug-outline</v-icon>
          Reportar problema
        </v-btn>
		    <v-btn 
          :color="parametros.color" 
          dark 
          block 
          @click="cerrar" 
          class="text-capitalize elevation-8"
          large
          > 
            Aceptar
          </v-btn>
    	</v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { BUG_REPORT_EVENT_NAME, buildManualBugContext } from '@/utils/bugReporter'

export default {
  props: [
    'parametros',
  ],

  computed: {
    esError() {
      return this.parametros && this.parametros.color !== 'success'
    },

    visible: {
      get() {
        return !!(this.parametros && this.parametros.dialogError)
      },
      set(valor) {
        this.parametros.dialogError = valor
      },
    },
  },

  methods: {
    cerrar() {
      this.parametros.dialogError = false
    },

    reportarProblema() {
      const mensaje = this.parametros && this.parametros.mensaje
        ? String(this.parametros.mensaje).trim()
        : ''

      this.parametros.dialogError = false

      const context = buildManualBugContext({
        store: this.$store,
        router: this.$router,
      })
      context.source = 'alerta'
      context.error = { message: mensaje || 'Error reportado desde alerta' }

      window.dispatchEvent(new CustomEvent(BUG_REPORT_EVENT_NAME, { detail: context }))
    },
  },
}
</script>

<style>
  .alerta-exito {
    padding: 8px 4px 8px 14px !important;
  }

  .alerta-exito__texto {
    font-size: 0.875rem;
    font-weight: 500;
    color: #fff;
    white-space: pre-line;
  }
</style>
